export const UserState = {
  HAS_ACCOUNT: '0',
  NO_ACCOUNT: '1',
  VERIFYING: '2',
  HAS_BUNDLE: '3',
  FAILED: '4',
};
